export const EDITABLE_PHONE_SLOTS = ['insurer_phone_number', 'appeal_phone_number']

export const snapShotInfo = [
  'member_id',
  'patient_first_name',
  'patient_last_name',
  'patient_dob',
  'date_of_provision_or_admission',
  'unique_identifier',
  'biller_name',
  'insurer_phone_number',
  'outstanding_balance',
  'insurer_claim_id',
  'callInformation_taxId',
  'biller_npi',
]

export const PatientInfo = [
  'patient_first_name',
  'patient_last_name',
  'patient_dob',
  'patient_sex',
  'patient_street1',
  'patient_street2',
  'patient_city',
  'patient_state',
  'patient_zip',
  'patient_id',
  'subscriber_id',
]

export const ProviderInfo = [
  'rendering_provider',
  'rendering_provider_npi',
  'biller_name',
  'provider_street1',
  'provider_street2',
  'provider_city',
  'provider_state',
  'provider_zip_code',
  'biller_npi',
  'callInformation_taxId',
  'ptan',
  'location',
]

export const InsuranceInfo = [
  'member_id',
  'insurer_name',
  'insurer_plan_name',
  'insurer_id',
  'group_id',
  'subscriber_id',
  'insurer_phone_number',
  'subscriber_first_name',
  'subscriber_dob',
  'subscriber_last_name',
  'subscriber_relationship',
  'subscriber_sex',
  'subscriber_zip_code',
]

export const AppealInfo = [
  'payer_appeal_case_number',
  'appeal_submission_date',
  'appeal_submission_method',
  'appeal_submission_tracking_number',
  'provider_appeal_fax_number',
  'provider_appeal_street1',
  'provider_appeal_street2',
  'provider_appeal_city',
  'provider_appeal_state',
  'provider_appeal_zipcode',
  'level_of_appeal',
  'appeal_phone_number',
]
